import api from './api';

export interface GrupoMcpUsuario {
    grupoMcp: number;
    usuario: string;
}

export interface GrupoMcpUsuarioSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
    grupoMcp?: number;
    usuario?: string;
}

export interface GrupoMcpUsuarioPagedResult {
    items: GrupoMcpUsuario[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const grupoMcpUsuarioService = {
    getGruposMcpUsuario: async (params: GrupoMcpUsuarioSearchParams): Promise<GrupoMcpUsuarioPagedResult> => {
        const response = await api.get<GrupoMcpUsuarioPagedResult>('/api/GrupoMcpUsuario', {
            params: {
                SearchTerm: params.searchTerm,
                PageNumber: params.pageNumber,
                PageSize: params.pageSize,
                GrupoMcp: params.grupoMcp,
                Usuario: params.usuario
            }
        });
        return response.data;
    },

    getGrupoMcpUsuario: async (grupoMcp: number, usuario: string): Promise<GrupoMcpUsuario> => {
        const response = await api.get<GrupoMcpUsuario>(`/api/GrupoMcpUsuario/${grupoMcp}/${encodeURIComponent(usuario)}`);
        return response.data;
    },

    getByGrupo: async (grupoMcp: number): Promise<GrupoMcpUsuario[]> => {
        const response = await api.get<GrupoMcpUsuario[]>(`/api/GrupoMcpUsuario/grupo/${grupoMcp}`);
        return response.data;
    },

    getByUsuario: async (usuario: string): Promise<GrupoMcpUsuario[]> => {
        const response = await api.get<GrupoMcpUsuario[]>(`/api/GrupoMcpUsuario/usuario/${encodeURIComponent(usuario)}`);
        return response.data;
    },

    create: async (dto: GrupoMcpUsuario): Promise<GrupoMcpUsuario> => {
        const response = await api.post<GrupoMcpUsuario>('/api/GrupoMcpUsuario', dto);
        return response.data;
    },

    delete: async (grupoMcp: number, usuario: string): Promise<void> => {
        await api.delete(`/api/GrupoMcpUsuario/${grupoMcp}/${encodeURIComponent(usuario)}`);
    }
};

export default grupoMcpUsuarioService;
